import { z } from 'zod';

export type UserCalendarCreate = z.infer<typeof schemaUserCalendarCreate>;
export const schemaUserCalendarCreate = z.object({
  accountId: z.number(),
  calendarId: z.string(),
  isWritable: z.boolean(),
  isReadable: z.boolean(),
  isSelected: z.boolean(),
  color: z.string(),
  displayType: z.number(),
  visibilityType: z.number(),
});

export type UserCalendarCreateBody = z.infer<
  typeof schemaUserCalendarCreateBody
>;
export const schemaUserCalendarCreateBody = z.object({
  calendars: z.array(schemaUserCalendarCreate),
});

export type UserCalendarUpdate = z.infer<typeof schemaUserCalendarUpdate>;
export const schemaUserCalendarUpdate = z.object({
  accountId: z.number(),
  calendarId: z.string(),
  isWritable: z.boolean(),
  isReadable: z.boolean(),
  isSelected: z.boolean(),
  color: z.string(),
  displayType: z.number(),
  visibilityType: z.number(),
});

export type UserCalendarUpdateBody = z.infer<
  typeof schemaUserCalendarUpdateBody
>;
export const schemaUserCalendarUpdateBody = z.object({
  calendars: z.array(schemaUserCalendarUpdate),
});

export type IntegrateCalendarListItem = z.infer<
  typeof schemaIntegrateCalendarListItem
>;
export const schemaIntegrateCalendarListItem = z.object({
  id: z.union([z.number(), z.string()]).nullable(),
  name: z.string().nullable(),
  color: z.string().nullable(),
});

export type CalendarListItem = z.infer<typeof schemaCalendarListItem>;
export const schemaCalendarListItem = z.object({
  id: z.string().nullable(),
  name: z.string().nullable(),
  isPrimary: z.boolean(),
  isIntegrated: z.boolean(),
  isSelected: z.boolean(),
  isWritable: z.boolean(),
  isReadable: z.boolean(),
  timeZone: z.string().nullable(),
  color: z.string(),
  displayType: z.number(),
  visibilityType: z.number(),
});
